/**
 * Tremolo - Modulation du volume par LFO
 * Effet classique de pulsation rythmique
 */

import * as Tone from 'tone';

export class Tremolo {
    constructor() {
        this.tremolo = new Tone.Tremolo({
            frequency: 4,        // Vitesse (Hz)
            depth: 0.5,          // Profondeur (0-1)
            spread: 0,           // Spread stéréo
            type: 'sine',        // Forme d'onde du LFO
            wet: 1
        }).start();

        this.input = this.tremolo;

        this._frequency = 4;
        this._depth = 0.5;
        this._mix = 0.3;
        this._isActive = true;

        this._outputGain = new Tone.Gain(this._mix);
        this.tremolo.connect(this._outputGain);
        this.output = this._outputGain;
    }

    get frequency() { return this._frequency; }
    get depth() { return this._depth; }
    get mix() { return this._mix; }

    setFrequency(hz) {
        this._frequency = hz;
        this.tremolo.frequency.value = hz;
    }

    setDepth(depth) {
        this._depth = depth;
        this.tremolo.depth.value = depth;
    }

    setMix(mix) {
        this._mix = mix;
        this._outputGain.gain.value = mix;
    }

    connectTo(destination) {
        this.output.connect(destination);
    }

    disconnect() {
        this.output.disconnect();
    }

    /**
     * Active/désactive l'effet (économie CPU)
     * Sets frequency to 0 when inactive to stop LFO modulation
     * @param {boolean} active - true pour activer, false pour désactiver
     */
    setActive(active) {
        if (active === this._isActive) return;
        this._isActive = active;

        if (active) {
            this.tremolo.frequency.value = this._frequency;
        } else {
            this.tremolo.frequency.value = 0;
        }
    }

    getParams() {
        return {
            frequency: this._frequency,
            depth: this._depth,
            mix: this._mix
        };
    }

    setParams(params) {
        if (params.frequency !== undefined) this.setFrequency(params.frequency);
        if (params.depth !== undefined) this.setDepth(params.depth);
        if (params.mix !== undefined) this.setMix(params.mix);
    }

    dispose() {
        this.tremolo.dispose();
        this._outputGain.dispose();
    }
}
